<template>
  <div>
    <!--卡片布局-->
    <el-card shadow="always">
      <!--操作栏-->
      <div class="search-items">
        <div>
          <el-input size="small" v-model="queryInfo.queryStr" placeholder="请输入工号或姓名进行查询" clearable @clear="loadData()">
            <el-button size="small" slot="append" icon="el-icon-search" @click="loadData()"></el-button>
          </el-input>
        </div>
        <div>
          <el-button size="small" type="primary" @click="handleAdd()">添加</el-button>
          <!-- <el-button size="small" type="success" disabled="true" @click="uploadFile()">批量导入</el-button>
          <el-button size="small" type="success" disabled="true" @click="exportToExcel()">导出</el-button> -->
          <el-button size="small" type="danger" @click="handleDeleteMulti()">删除所选</el-button>
        </div>
      </div>
      <!--表格-->
      <el-table :data="tableData" stripe border style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50">
        </el-table-column>
        <el-table-column prop="tno" width="100" label="工号">
        </el-table-column>
        <el-table-column prop="name" width="100" label="姓名">
        </el-table-column>
        <el-table-column width="60" label="性别">
          <template slot-scope="scope">{{scope.row.sex=='1'?'男':'女'}}</template>
        </el-table-column>
        <el-table-column prop="phone" width="140" label="手机号码">         
        </el-table-column>
        <el-table-column prop="email" width="180" label="电子邮箱">         
        </el-table-column>
        <el-table-column prop="cnames" label="开设课程">
          <!-- <template slot-scope="scope">{{courseName(scope.row.sex)}}</template> -->
        </el-table-column>
        <el-table-column prop="pnames" label="开设项目">
          <!-- <template slot-scope="scope">{{projectName(scope.row.sex)}}</template> -->
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="handleUpdate(scope.row)"></el-button>
            <el-button type="danger" icon="el-icon-delete" @click="handleDeleteOne(scope.row.id)" size="mini"></el-button>
          </template>
        </el-table-column>
        <el-table-column label="重置密码" width="90">
          <template slot-scope="scope">
            <el-button type="warning" icon="el-icon-magic-stick" size="mini" @click="handleResetPassword(scope.row)"></el-button>
          </template>
        </el-table-column>         
      </el-table>

      <!--分页-->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.currentPage" :page-sizes="[1,5,10,100]" :page-size="queryInfo.pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!--编辑对话框-->
    <el-dialog :title="isEdit?'修改教师信息':'添加教师信息'" :visible.sync="dialogVisible" @close="resetDialog" :close-on-click-modal="false">
      <teacher-form v-if="dialogVisible" :form='form' :isEdit='isEdit' @afterSubmit="afterSubmit" :lazy="true">        
      </teacher-form>
    </el-dialog> 
  </div>
</template>

<script>
import { resetTeacherPassword } from '@/api/login'
import { selectTeacherList,  deleteTeacher } from '@/api/teacher'
import CommonUtil from "@utils/common-util"
import TeacherForm from "./teacherForm.vue"
const defaultForm = {
  tno: '',
  name: '',
  sex: '',
  age: '',
  email: ''
}
export default {
  inject: ['reload'],
  name: "teacherIndex",
  components: { TeacherForm },
  data() {
    return {
      form: Object.assign({}, defaultForm),
      dialogVisible: false,//添加用户对话框
      infoDialog: false,//个人信息对话框
      formLabelWidth: '120px',
      selectNos: [],
      tableData: [],       //分页查询所有数据
      queryInfo: {
        queryStr: '',
        currentPage: 1,
        pageSize: 100
      },
      total: 0,
      file: null,
      allTableData: [],     //表格所有数据
      multipleSelection: [],
      isEdit: false
    }
  },
  computed: {
    courseName() {
      return function (classType) {
        return "机械工程及自动化"
      }
    },
    projectName() {
      return function (classType) {
        return "项目一,项目二"
      }
    },
  },
  created() {
    this.loadData();//分页条件获取所有学生信息
  },
  methods: {
    //添加对象
    handleAdd() {
      this.dialogVisible = true;
      this.isEdit = false;
      this.form = Object.assign({}, defaultForm);
    },
    //编辑对象 
    handleUpdate(row) {
      this.dialogVisible = true;
      this.isEdit = true;
      this.form = _.assignIn({}, row)
    },

    afterSubmit() {
      this.dialogVisible = false
      this.loadData()
    },
  //重置教师密码
    handleResetPassword(row) {
      this.$confirm('确认重置该教师密码？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetTeacherPassword(row.tno).then(response => {
          if (response.data.status == 200) {
            this.$message({
              message: '操作成功！',
              type: 'success',
              duration: 2000
            });
          } else {
            //修改失败
            that.$message({
              type: 'error',
              message: response.data.data.detailMessage
            })
          }
        })
      });

    },    
    resetDialog() {
      //重置对话框
      // this.$refs['form'].resetFields();
      this.dialogVisible = false;
    },
    exportToExcel() {
      //导出excel
      require.ensure([], () => {
        let { exportJsonToExcel } = require("@excel/Export2Excel.js");
        // 表头
        let tHeader = [
          "学号",
          "密码",
          "姓名",
          "性别",
          "年龄",
          "学院",
          "身份证",
          "身份"
        ];
        //表头对应字段名，要和下面数据key对应
        let filterVal = [
          "sno",
          "spassword",
          "sname",
          "ssex",
          "sage",
          "sdept",
          "sid",
          "power"
        ];
        // 数据来源
        let list = this.allTableData;
        let data = this.formatJson(filterVal, list); //数据格式化
        var index1 = "所有学生信息"; //导出时文件名
        exportJsonToExcel(tHeader, data, index1); //导出文件
      });
    },
    formatJson(filterVal, jsonData) {
      // 导出excel数据格式化
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    uploadFile() {
      //上传文件
      //显示正在加载中
      // this.common.uploadData(this, this.apiUrl.addMultipleTeacher);
    },
    //删除所选
    handleDeleteMulti() {
      let ids = []
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        ids = _.map(this.multipleSelection, 'id')        
      }
      CommonUtil.deleteMultiple(ids, deleteTeacher, this.loadData)
    },
    //删除单个
    handleDeleteOne(id) {
      CommonUtil.deleteOne([id], deleteTeacher, this.loadData)
    },

    handleSelectionChange(val) {
      //监听多选框值动态变化的事件
      this.multipleSelection = val;
    },
    //加载列表数据
    loadData() {
      //分页条件获取所有学生信息     
      let params = {
        queryStr: this.queryInfo.queryStr,
        currentPage: this.queryInfo.currentPage,
        pageSize: this.queryInfo.pageSize
      }
      selectTeacherList(params).then(response => {
        this.tableData = response.data.data.entries;
        this.total = response.data.data.total;
      });
    },
    changeFile(file) {
      //改变文件触发事件
      this.file = file;
    },
    beforeRemove(file) {
      //移除文件触发事件
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSizeChange(val) {
      //监听pageSize
      this.queryInfo.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      //监听currentPage
      this.queryInfo.currentPage = val;
      this.loadData();
    },
    getAllTeacher() {
      //用于excel的导出
      this.common.getAllData(this, this.apiUrl.selectAllTeachers);
    }
  }
}
</script>

